import request from '../../config/axiosConfig';
import {
  GET_LIST_PREMIUMS, GET_PREMIUM_INFO, CREATE_PREMIUM,
  UPDATE_PREMIUM, DELETE_PREMIUM, CHECK_PREMIUM
} from '../../constants/apiEndPoint';

export const getListPremiumsRequest = async (data) => {
  const result = await request({ url: GET_LIST_PREMIUMS, method: 'POST', data });
  return result?.data.data;
};

export const getPremiumInfoRequest = async (data) => {
  const result = await request({ url: GET_PREMIUM_INFO, method: 'POST', data });
  return result?.data.data;
};

export const createPremiumRequest = async (data) => {
  const result = await request({ url: CREATE_PREMIUM, method: 'POST', data });
  return result?.data;
};

export const updatePremiumRequest = async (data) => {
  const result = await request({ url: UPDATE_PREMIUM, method: 'POST', data });
  return result?.data;
};

export const deletePremiumRequest = async (data) => {
  const result = await request({ url: DELETE_PREMIUM, method: 'POST', data });
  return result?.data;
};

export const checkPremiumRequest = async (data) => {
  const result = await request({ url: CHECK_PREMIUM, method: 'POST', data });
  return result?.data.data;
};
